import { createVanIconComponent } from "./van"

const ShopCollect = createVanIconComponent("shop-collect")
export default ShopCollect
